import { Theme } from "@material-ui/core/styles";

// ----------------------------------------------------------------------

export default function Dialog(theme: Theme) {
  return {
    MuiDialog: {
      styleOverrides: {
        paper: {
          boxShadow: theme.customShadows.z24,
          "&.MuiPaper-rounded": {
            borderRadius: theme.shape.borderRadiusMd
          },
          "&.MuiDialog-paperFullScreen": {
            borderRadius: 0
          },
          "&.MuiDialog-paper .MuiDialogActions-root": {
            padding: theme.spacing(3)
          },
          "@media (max-width: 600px)": {
            // Default mobile margin for centered dialogs. Explicitly
            // NOT applied to fullScreen dialogs — their whole point is
            // to cover the viewport edge-to-edge, and a 16px margin on
            // a fullScreen Paper leaves a visible strip on every side
            // (in RTL it reads as a "gap on the left" since that's
            // where attention lands when reading right-to-left).
            "&:not(.MuiDialog-paperFullScreen)": {
              margin: theme.spacing(2)
            }
          },
          "@media (max-width: 663.95px)": {
            "&.MuiDialog-paperWidthSm.MuiDialog-paperScrollBody": {
              maxWidth: "100%"
            }
          }
        },
        paperFullWidth: {
          width: "100%"
        }
      }
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3, 3, 0)
        }
      }
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          borderTop: 0,
          borderBottom: 0,
          padding: theme.spacing(3),
          // Capture the scroll inside the dialog: when the content reaches
          // its top/bottom, don't let the wheel/touch event chain through to
          // whatever scroll container sits underneath the modal. Applied at
          // the theme level so every Dialog in the app behaves this way.
          overscrollBehavior: "contain"
        }
      }
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          "& > :not(:first-of-type)": {
            marginLeft: theme.spacing(1.5)
          }
        }
      }
    }
  };
}
